import React from 'react';
import './promotedLabel.scss';

export const PromotedLabel = () => {
    return (
        <div className="eds-promoted-label--container">
            <span className="eds-text-bs eds-promoted-label--text eds-text-color--ui-600 eds-text-weight--heavy">
                Promoted
            </span>
        </div>
    );
};
